<dcr-logo logo="diekeure:square:full" class="dk-logo"></dcr-logo>

<div class="[ flex flex-wrap w-full gap-xs ]">
  <div class="column">
    <h6>Over</h6>
    <ul class="[ stack stack-space-s p-none style-none m-none ]">
      <li class="platform-name">
        <a href="#about">{{ platform }}</a>
      </li>
      <li><a href="https://www.diekeure.be/" target="_blank">die Keure</a></li>
      <li><a href="/#faq">Veelgestelde vragen</a></li>
    </ul>
  </div>

  <div class="column">
    <h6>Contact</h6>
    <address>
      <div>Kleine Pathoekeweg 3</div>
      <div>8000 Brugge</div>
    </address>
    <dcr-outline-button href="#contact" label="Contacteer de helpdesk" class="w-fit"></dcr-outline-button>

    <ul class="[ flex gap-m p-bs-m ][ p-none  m-none ]">
      <li>
        <a href="https://www.facebook.com/DieKeureEducatief" aria-label="Facebook" target="_blank">
          <dcr-icon size="l" icon="portal:facebook"> </dcr-icon>
        </a>
      </li>
      <li>
        <a href="https://www.instagram.com/diekeureeducatief" aria-label="Insstagram" target="_blank">
          <dcr-icon size="l" icon="portal:instagram"> </dcr-icon>
        </a>
      </li>
      <li>
        <a href="https://www.pinterest.com/diekeure" aria-label="Pinterest" target="_blank">
          <dcr-icon size="l" icon="portal:pinterest"> </dcr-icon>
        </a>
      </li>
      <li>
        <a href="https://www.youtube.com/@UitgeverijDieKeure" aria-label="YouTube" target="_blank">
          <dcr-icon size="l" icon="portal:youtube"> </dcr-icon>
        </a>
      </li>
    </ul>
  </div>

  <div class="column">
    <h6>Gebruik</h6>
    <ul class="[ stack stack-space-s p-none m-none ]">
      <li><a href="/legals/privacy">Privacy</a></li>
      <!-- <li><a href="/legals/ai">A.I. Act</a></li> -->
      <li><a href="#" (click)="openCookieConsent($event)">Cookievoorkeuren</a></li>
      <li><a href="/legals/gebruiksvoorwaarden">Gebruiksvoorwaarden</a></li>
      <li><a href="/legals/verkoopsvoorwaarden">Verkoopsvoorwaarden</a></li>
    </ul>
  </div>
</div>

<div class="[ stack stack-space-m w-full ]">
  <dcr-divider></dcr-divider>
  <ul class="[ flex flex-wrap gap-xs ][ p-none ][ uppercase ]">
    <li class="column"><a href="https://www.diekeure.be" target="_blank" class="w-fit">Die Keure</a></li>
    <li class="column"><a href="https://www.diekeure.be/educatief" target="_blank" class="w-fit">Educatief</a></li>
    <li class="column"
      ><a href="https://www.diekeure.be/professional" target="_blank" class="w-fit">Professional</a></li
    >
  </ul>
  <dcr-divider></dcr-divider>
</div>

<div class="[ label-small on-surface-variant ]"> &copy; die Keure {{ year }} </div>

<campus-cookies-content
  *ngIf="cookieInputs$ | async as cookieInputs"
  [linkcookies]="cookieInputs.link"
  [linkCookiesLabel]="'in onze privacy voorwaarden'"
  [setVisible]="cookieInputs.visibility"
  [errormessage]="cookieInputs.errormessage"
  (close)="closeCookieConsent()"
></campus-cookies-content>
